export default function RadioButtonSelectedIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      {...props}
    >
      <path
        id="Subtract"
        // ATTENTION: This is required to use as fill-rule instead of fillRule for some unknown reason, because if we don't put this the circle is fully filled
        fill-rule="evenodd"
        clipRule="evenodd"
        d="M6.58319 3.89317C8.18657 2.82183 10.0716 2.25 12 2.25C14.585 2.25273 17.0634 3.28084 18.8913 5.10872C20.7192 6.93661 21.7473 9.41498 21.75 12C21.75 13.9284 21.1782 15.8134 20.1068 17.4168C19.0355 19.0202 17.5127 20.2699 15.7312 21.0078C13.9496 21.7458 11.9892 21.9389 10.0979 21.5627C8.20656 21.1865 6.46928 20.2579 5.10571 18.8943C3.74215 17.5307 2.81355 15.7934 2.43735 13.9021C2.06114 12.0108 2.25422 10.0504 2.99218 8.26884C3.73013 6.48726 4.97982 4.96451 6.58319 3.89317ZM9.49994 8.25839C10.24 7.76392 11.11 7.5 12 7.5C13.1931 7.5013 14.3369 7.97583 15.1805 8.81946C16.0242 9.66309 16.4987 10.8069 16.5 12C16.5 12.89 16.2361 13.76 15.7416 14.5001C15.2471 15.2401 14.5443 15.8169 13.7221 16.1575C12.8998 16.4981 11.995 16.5872 11.1221 16.4135C10.2492 16.2399 9.44736 15.8113 8.81802 15.182C8.18868 14.5526 7.7601 13.7508 7.58647 12.8779C7.41283 12.005 7.50195 11.1002 7.84254 10.2779C8.18314 9.45566 8.75991 8.75285 9.49994 8.25839Z"
        fill="currentColor"
      />
    </svg>
  );
}
